import cn from 'classnames';
import dayjs from 'dayjs';
import { FC } from 'react';

import { EOrderStatus, OrderDateRentModel } from '@/types/orders';

import { useTranslate } from '@/shared/hooks/use-translate';

import * as Styled from './styled';

type TProps = {
    dateRent: OrderDateRentModel;
    status?: EOrderStatus;
};

export const RentDate: FC<TProps> = ({ dateRent, status }) => {
    const { t } = useTranslate();

    const format = (date: Date | string) => dayjs(date).locale('ru').format('D MMMM');

    return (
        <Styled.Wrapper>
            <div className="date">
                <div>{t('Дата начала аренды')}</div>
                <div>{format(dateRent.start)}</div>
            </div>
            {status !== EOrderStatus.Sent_to_court && (
                <div className={cn('date', 'date_return')}>
                    {/*TODO 230*/}
                    <div>{status === EOrderStatus.Closed ? t('Возвращен') : t('Плановая дата возврата')}</div>
                    <div>{format(dateRent.return)}</div>
                </div>
            )}
        </Styled.Wrapper>
    );
};
